/**
 * Role-based Dashboard Router
 * Shows different dashboards based on user role
 */
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Dashboard from './Dashboard';
import ServiceStaffDashboard from './ServiceStaffDashboard';
import HouseKeepingDashboard from './HouseKeepingDashboard';
import FrontOfficeDashboard from './FrontOfficeDashboard';

export default function RoleBasedDashboard({ user }) {
  const navigate = useNavigate();
  
  // For service_staff and house_keeping, show mobile-friendly dashboards
  if (user?.role === 'service_staff') {
    return <ServiceStaffDashboard user={user} />;
  }
  
  if (user?.role === 'house_keeping') {
    return <HouseKeepingDashboard user={user} />;
  }
  
  if (user?.role === 'front_office') {
    return <FrontOfficeDashboard user={user} />;
  }
  
  // For other roles (super_admin, company_admin, hotel_admin, manager), show regular dashboard
  return <Dashboard user={user} />;
}
